export enum InitiateIvConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'initiateIv/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'initiateIv/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  NOT_IMPLEMENTED = 'initiateIv/NOT_IMPLEMENTED',
  GET_SITE = 'initiateIv/GET_SITE',
  SET_SITE = 'initiateIv/SET_SITE',
  SET_SITE_PNNV = 'initiateIv/SET_SITE_PNNV',
  SAVE_SITE = 'initiateIv/SAVE_SITE',
  DELETE_SITE = 'initiateIv/DELETE_SITE',
  SET_GAUGE = 'initiateIv/SET_GAUGE',
  GET_TYPE = 'initiateIv/GET_TYPE',
  SET_TYPE = 'initiateIv/SET_TYPE',
  SAVE_TYPE = 'initiateIv/SAVE_TYPE',
  DELETE_TYPE = 'initiateIv/DELETE_TYPE',
  SET_RESPONSE = 'initiateIv/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'initiateIv/SET_RESPONSE_PNNV',
  SAVE_INITIATE_IV = 'initiateIv/SAVE_INITIATE_IV',
  RESET_STATE = 'initiateIv/RESET_STATE',
  SET_ADD_TO_TIMELINE = 'initiateIv/SET_ADD_TO_TIMELINE',
  SET_STATE = 'initiateIv/SET_STATE',
  SET_DATE_TIME = 'initiateIv/SET_DATE_TIME',
  SET_ASSESSED_BY = 'initiateIv/SET_ASSESSED_BY',
  SET_PTA = 'initiateIv/SET_PTA',
  ON_SELECT_INITIATE_IV = 'initiateIv/ON_SELECT_INITIATE_IV',
  SET_UPDATE_INPUT_ROWS = 'initiateIv/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'initiateIv/SET_DATE',
  SET_TIME = 'initiateIv/SET_TIME',
  SET_ATTEMPTS = 'initiateIv/SET_ATTEMPTS',
  SET_PROCEDURE_COMPLICATIONS = 'initiateIv/SET_PROCEDURE_COMPLICATIONS',
  SET_AUTHORIZATION = 'initiateIv/SET_AUTHORIZATION',
  SET_SUCCESSFUL_ATTEMPT = 'initiateIv/SET_SUCCESSFUL_ATTEMPT',
  SET_COMMENTS = 'initiateIv/SET_COMMENTS',
  SET_ROLE_PERFORMING = 'initiateIv/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'initiateIv/SET_ROLE_PERFORMING_PNNV',
  SET_INITIATE_IV_DEFAULTS = 'initiateIv/SET_INITIATE_IV_DEFAULTS',
}
